<template>
  <breadCrumbs title="Tour" main="Bonus UI" title1="Tour" />
      <div class="container-fluid text-start">
        <div class="user-profile">
          <div class="row">
            <tourProfile />
            <tourDetail />
            <div class="col-xl-9 col-lg-12 col-md-7 xl-65">
              <div class="row">
                <post1Page />
                <post2Page />
                <post3Page/>
              </div>
            </div>
            <v-tour name="myTour" :steps="steps" :options="tourOptions"></v-tour>
          </div>
        </div>
      </div>
  </template>
  <script>
  import tourProfile from "./tourProfile.vue";
  import tourDetail from "./tourDetail.vue";
  import post1Page from "../../users/profile/post1Page.vue";
  import post2Page from "../../users/profile/post2Page.vue";
  import post3Page from "../../users/profile/post3Page.vue";
  export default {
    components: {
      tourProfile,
      tourDetail,
      post1Page, post2Page, post3Page
    },
    data() {
      return {
        tourOptions: {
          useKeyboardNavigation: true,
          labels: {
            buttonSkip: "Skip",
            buttonPrevious: "Back",
            buttonNext: "Next",
            buttonStop: "Done",
          },
        },
        toogle: true,
        steps: [
          {
            target: "#profile-tour",
            content: "This is Profile image",
          },
          {
            target: "#update-profile-tour",
            content: "Change Profile image here",
          },
          {
            target: "#info-bar-tour",
            content: "This is the your details",
          },
          {
            target: "#social-bar-tour",
            content: "This is your Social details",
          },
          {
            target: "#first-post-tour",
            content: "This is the your first Post",
            params: {
              placement: "top",
            },
          },
          {
            target: "#last-post-tour",
            content: "This is the your last Post",
            params: {
              placement: "top",
            },
          },
        ],
      };
    },
    mounted: function () {
      this.$tours["myTour"].start();
    },
  };
  </script>